import { render, staticRenderFns } from "./UnidadeOperacaoLista.vue?vue&type=template&id=3855e83e&"
import script from "./UnidadeOperacaoLista.vue?vue&type=script&lang=js&"
export * from "./UnidadeOperacaoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports